import { getAxiosInstance } from '../../react/utils/networkUtil';
import { AppSuccess } from '../models/AppSuccess';
import { CollectFormTemplate } from '../models/CollectFormTemplate';
import { FormSchema_V2 } from '../models/CollectFormV2';

/**
 * API request/response types for CollectFormTemplate
 */
export type CollectFormTemplate_Create_Request = {
  name: string;
  description?: string;
  content: FormSchema_V2;
  sqlite_files?: string;
};

export type CollectFormTemplate_Update_Request = Partial<CollectFormTemplate_Create_Request>;

/**
 * Get all templates
 */
export const remote_getTemplates = async (): Promise<CollectFormTemplate[]> => {
  const response = await getAxiosInstance().get('/api/collect-form-templates-ext');
  return response.data;
};

/**
 * Get one template by UUID
 */
export const remote_getOneTemplate = async (uuid: string): Promise<CollectFormTemplate> => {
  const response = await getAxiosInstance().get(`/api/collect-form-templates-ext/${uuid}`);
  return response.data;
};

/**
 * Create a new template
 */
export const remote_createTemplate = async (
  body: CollectFormTemplate_Create_Request,
): Promise<AppSuccess<CollectFormTemplate>> => {
  const response = await getAxiosInstance().post('/api/collect-form-templates-ext', body);
  return response.data;
};

/**
 * Update an existing template
 */
export const remote_updateTemplate = async (
  uuid: string,
  body: CollectFormTemplate_Update_Request,
): Promise<AppSuccess<CollectFormTemplate>> => {
  const response = await getAxiosInstance().put(`/api/collect-form-templates-ext/${uuid}`, body);
  return response.data;
};

/**
 * Delete a template
 */
export const remote_deleteTemplate = async (uuid: string): Promise<AppSuccess<any>> => {
  const response = await getAxiosInstance().delete(`/api/collect-form-templates-ext/${uuid}`);
  return response.data;
};

/**
 * Get presigned URL for SQLite file download
 */
export const remote_getSqliteUrl = async (uuid: string): Promise<{ url: string | null; expiresIn: number }> => {
  const response = await getAxiosInstance().get(`/api/collect-form-templates-ext/${uuid}/sqlite-url`);
  return response.data.data;
};

/**
 * Exported API object
 */
export const CollectFormTemplateAPIs = {
  remote_getTemplates,
  remote_getOneTemplate,
  remote_createTemplate,
  remote_updateTemplate,
  remote_deleteTemplate,
  remote_getSqliteUrl,
};
